export default __webpack_public_path__ + "static/media/cancel.4b4a0861.svg";